import { FunctionComponent, useContext } from 'react';
import { FilterBarContext } from './FilterBarContext';
import { Button } from '@mui/material';
import { useTranslation } from '@/lib';
import { cn } from '@/lib/utils/utils';

interface FilterBarSearchButtonProps {
  isLoading?: boolean;
  className?: string;
  size?: 'small' | 'medium';
}

const FilterBarSearchButton: FunctionComponent<FilterBarSearchButtonProps> = ({ isLoading, className, size }) => {
  const { triggerSearch } = useContext(FilterBarContext);
  const { t } = useTranslation();

  return (
    <Button loading={isLoading} variant="contained" color="primary" size={size} onClick={triggerSearch} className={cn(className)}>
      {t('search')}
    </Button>
  );
};

export default FilterBarSearchButton;
